export default __webpack_public_path__ + "/dist/images/demo.c9e37100a7b6a6ac870c43a5081197e9.svg";